import { useCallback, useEffect, useState } from 'react'

import { useMutationObserver } from './useMutationObserver'

/**
 * Given an SVG Ref this hook will return the dimensions of its bounding box.
 */
export const useSvgBbox = (
  margin: { x: number; y: number } = { x: 0, y: 0 },
) => {
  const [svgDimensions, setSvgDimensions] = useState({ width: 0, height: 0 })

  const computeSvgDimensions = useCallback(() => {
    const { width, height } = svgRootRef.current!.getBBox()

    const svgWidth = width + margin.x
    const svgHeight = height + margin.y

    setSvgDimensions({
      width: svgWidth,
      height: svgHeight,
    })
    // Deliberately not including the ref in the deps array
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const svgRootRef = useMutationObserver<SVGSVGElement>(() => {
    computeSvgDimensions()
  })

  // OnMount
  useEffect(() => {
    if (svgRootRef.current) {
      computeSvgDimensions()
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { ref: svgRootRef, ...svgDimensions }
}
